<template>
    <div class="form-check">
        <input
            :id="filter.id"
            class="form-check-input ms-auto me-2"
            type="checkbox"
            :checked="filter.checked"
            @change="provider.setCheckFilter(filter, $event.target?.checked)"
        >
        <label class="form-check-label" :class="provider.getConfig('checkFilterLabelClass')" :for="filter.id">
            {{ filter.label }}
        </label>
    </div>
</template>

<script lang="ts" setup>
import {inject} from "vue";
import type JobApiProvider from "../JobApiProvider.ts";
import {KeyJobApiProvider} from "../symbols.ts";
import type {CheckFilterValue} from "../types.ts";

interface PropsType {
    filter: CheckFilterValue
}

defineProps<PropsType>();

const provider = inject<JobApiProvider>(KeyJobApiProvider) as JobApiProvider;

</script>
